/* eslint-disable no-magic-numbers */
import { PayloadAction } from '@reduxjs/toolkit';
import { MAP_EDIT_ACTIONS } from '@/redux/mapEditTools/mapEditTools.constants';
import { MapEditToolsState } from '@/redux/mapEditTools/mapEditTools.types';
import { LayerImageAdapter } from '@/utils/layer/LayerImageAdapter';
import { LayerTextAdapter } from '@/utils/layer/LayerTextAdapter';
import { LayerRectAdapter } from '@/utils/layer/LayerRectAdapter';
import { LayerOvalAdapter } from '@/utils/layer/LayerOvalAdapter';
import { LayerLineAdapter } from '@/utils/layer/LayerLineAdapter';

export const mapEditToolsSetActiveActionReducer = (
  state: MapEditToolsState,
  action: PayloadAction<keyof typeof MAP_EDIT_ACTIONS | null>,
): void => {
  state.activeAction = action.payload;
};

export const mapEditToolsSetLayerObjectReducer = (
  state: MapEditToolsState,
  action: PayloadAction<
    LayerImageAdapter | LayerTextAdapter | LayerRectAdapter | LayerOvalAdapter | null
  >,
): void => {
  state.layerObject = action.payload;
  if (action.payload !== null) {
    state.layerLine = null;
  }
};

export const mapEditToolsSetLayerLineReducer = (
  state: MapEditToolsState,
  action: PayloadAction<LayerLineAdapter | null>,
): void => {
  state.layerLine = action.payload;
  if (action.payload !== null) {
    state.layerObject = null;
  }
};
